// extracted by mini-css-extract-plugin
export default {"frLineItemsContainer":"style_frLineItemsContainer__w8zvi","list":"style_list__vBI3B","deleteButton":"style_deleteButton__x14Ox","inputField":"style_inputField__wt0Vp"};